import { useContext } from "react";
import TuitionFeesContext from "src/context/tuitionFeesContext.js";

const useTuitionFees = () => {
  const value = useContext(TuitionFeesContext);
  return value;
};

export default useTuitionFees;
